webpackJsonp([9030065451625],{

/***/ 1555:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ScheduleTemplateRangeInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"appointmentTypeId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"range","type":{"kind":"SCALAR","name":"Numrange","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-schedule-template-range-input-f2d18fe4d834ec4cb557.js